import React from 'react';
import {
 PrimaryButton, TextInput, Pulse, DropDown, SecondaryButton 
} from 'wf-react-component-library';
import Premiums from './Premiums';
import ItemApi from '../api/virs/ItemApi';
import validateVirmItem, { validatePremium, validateBurdenItem, validatePremiumItem } from '../services/validation/VirmItem';
import { getCoolersByVendor } from '../api/p3/VendorCoolerApi';
import { getItemsByItemCodes } from '../api/p3/ItemApi'
import appConfig from '../configuration/AppConfig';

import './EditItemModal.scss';
import { Logger } from '@aws-amplify/core';

const logger = new Logger('EditItemModel.js');

class EditItemModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: this.props.selectedItems,
      currentItemLocation: 0,
      selectedItem: this.props.selectedItems[0],
      errorMessages: {},
      premiumErrorMessages: {},
      coolers: {},
      coolerKeys: [],
      isLoadingData: false,
      currentVendorCategory: this.props.currentVendorCategory,
      isSaving: false
    };

    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSaveAndNextClose = this.handleSaveAndNextClose.bind(this);
    this.handlePremiumChange = this.handlePremiumChange.bind(this);
  }

    componentDidMount = async () => {
      this.setState({ isLoadingData: true });

      logger.debug('requesting vendor/coolers from api for vendor ' + this.state.selectedItem.vendorId);
      const coolerDetails = await getCoolersByVendor(this.state.selectedItem.vendorId);
      logger.debug('received cooler info');
      const coolers = {};
      const coolerKeys = [];
  
      coolerDetails.sort((a, b) => (a.code > b.code ? 1 : -1));
      coolerDetails.forEach((cooler) => {
        coolers[cooler.code] = cooler.code;
      });
      Object.keys(coolers).forEach(key => coolerKeys.push(key));

      let selectedItem = await this.determineUnitType(this.state.selectedItem);
      selectedItem.premium = selectedItem.premium ?? {};

      this.setState({
        coolers, isLoadingData: false, coolerKeys, selectedItem
      });
    }

    determineUnitType = async (selectedItem) => {
      const itemDetails = await getItemsByItemCodes(selectedItem.itemId)
      logger.debug(`fetched item details: ${JSON.stringify(itemDetails)}`)
      const selectedItemGroup = itemDetails.length > 0 ? itemDetails[0].itemGroupCode : ''
      selectedItem.isBurdenFreightItem = (selectedItemGroup !== '' && selectedItemGroup !== 'M' && selectedItemGroup !== 'SB' && selectedItemGroup !== 'MB')
      if (selectedItem.isBurdenFreightItem) {
        if (!selectedItem.unitType) {
          if (this.state.currentVendorCategory === '') {
            selectedItem.unitType = ''
          } else {
            selectedItem.unitType = (this.state.currentVendorCategory == "meat" || this.state.currentVendorCategory == "seafood") ? 'WT' : 'CTN'
            selectedItem.isDirty = true
          }
        }
      }
      return selectedItem
    }
    
    closeModal = () => {
      this.props.closeModal();
    }

    handleChange = (e) => {
      const { selectedItem, errorMessages } = this.state;
      selectedItem[e.target.name] = e.target.value;
      selectedItem.isDirty = true;
      errorMessages[e.target.name] = '';

      const premiumValidation = validatePremium(selectedItem.premium);
      const itemValidation = validatePremiumItem(selectedItem);
      const premiumErrors = { ...premiumValidation.errors, ...itemValidation.errors };

      this.setState({ selectedItem, errorMessages, premiumErrorMessages: premiumErrors === null ? {} : premiumErrors});
    }

    handlePremiumChange = (premium) => {
      const { selectedItem } = this.state;
      selectedItem.premium = {...premium};
      selectedItem.isDirty = true;

      const premiumValidation = validatePremium(selectedItem.premium);
      const itemValidation = validatePremiumItem(selectedItem);
      const premiumErrors = { ...premiumValidation.errors, ...itemValidation.errors };

      this.setState({ selectedItem, premiumErrorMessages: premiumErrors === null ? {} : premiumErrors });
    }

    // action == 0, NEXT
    // action == 1, CLOSE
    handleSaveAndNextClose = async (action) => {
      const { selectedItem, selectedItems, coolerKeys } = this.state;
      const { currentUser } = this.props;
      this.setState({isSaving: true});

      // validate
      const { errors } = selectedItem?.isBurdenItem ? validateBurdenItem(selectedItem) : validateVirmItem(selectedItem, coolerKeys);
      let premiumErrors = null;

      if ('premium' in selectedItem && Object.getOwnPropertyNames(selectedItem.premium).length !== 0) {
        const premiumValidation = validatePremium(selectedItem.premium);
        const itemValidation = validatePremiumItem(selectedItem);

        premiumErrors = { ...premiumValidation.errors, ...itemValidation.errors };
      }

      if (errors === null && (premiumErrors === null || premiumErrors === undefined || Object.getOwnPropertyNames(premiumErrors).length === 0)) {
        try {
          if (selectedItem.isDirty) {
            selectedItem.modifiedBy = currentUser
            
            // treating this like a number for passing the payload to Dynamo, numbers cannot be emptry strings
            if ('deliveredCost' in selectedItem && selectedItem.deliveredCost === '') {
              selectedItem.deliveredCost = null;
            }

            // Country of Orgin is required to run the PATCH
            // Burden Items do not have a Country of Origin so we are defaulting the value to USA
            // On the Dashboard, we will check if the item is a Burden Item and ignore this value if that is the case
            if (selectedItem.isBurdenItem) {
              selectedItem.countryOfOrigin = "USA";
            }
            
            const resp = await ItemApi.patch(selectedItem.vendorId, selectedItem, selectedItem.vendorItemId);
            
            logger.debug('the patch was a success');
            logger.debug(resp);
          }

          // Update selectedItems
          selectedItems[this.state.currentItemLocation] = selectedItem;

          if (action === 1) {
            this.setState({isSaving: false});
            this.closeModal();
          }

          if (action === 0) {
            let { currentItemLocation } = this.state;
            currentItemLocation += 1;
            const itemCount = selectedItems.length;

            // start from the beginning
            if (currentItemLocation === itemCount) currentItemLocation = 0;
            const newSelectedItem = await this.determineUnitType(selectedItems[currentItemLocation]);
            this.setState({
              currentItemLocation,
              selectedItem: newSelectedItem,
              selectedItems,
              isSaving: false
            });
          }

          if (action === -1) {
            let { currentItemLocation } = this.state;
            currentItemLocation -= 1;
            const itemCount = selectedItems.length;

            // start from the end
            if (currentItemLocation === -1) currentItemLocation = itemCount-1;
            const newSelectedItem = await this.determineUnitType(selectedItems[currentItemLocation]);
            this.setState({
              currentItemLocation,
              selectedItem: newSelectedItem,
              selectedItems,
              isSaving: false
            });
          }
        } catch (err) {
          logger.debug('error calling patch from ui');
          logger.debug(err);
        }
      } else {
        this.setState({ isSaving: false, errorMessages: errors === null ? {} : errors, premiumErrorMessages: premiumErrors === null ? {} : premiumErrors });
      }
    }

    render() {
      const {
        selectedItem, selectedItems, errorMessages, currentVendorCategory, isSaving
      } = this.state;

      const unitTypeOptions = selectedItem?.isBurdenItem ? { CTN: "CTN", WEIGHT: "WEIGHT", PO: "PO", PALLET: "PALLET" } : { CTN: "CTN", WT: "WT" };

      return (
        <div>
          {this.state.isLoadingData || !selectedItem
            ? <div className="flex-container-row"><Pulse text="Loading Data..." /></div>
            : (
                <div className="flex-container-row item-details-container show">
                  
                  { !selectedItem?.isBurdenItem
                  ? <div className="flex-container-row input">
                    <div className="flex-container-column input">
                      <TextInput value={selectedItem.itemId} isDisabled labelName="Item Number" id="VendorItemNumber" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input description">
                      <TextInput errorMsg={errorMessages.description} isDisabled value={selectedItem.description} labelName="Description" id="description" handleChange={this.handleChange} />
                    </div>
                    { ('certification' in selectedItem && selectedItem.certification !== null)
                     ? <div className="flex-container-column input">
                       <TextInput value={selectedItem.certification.name} isDisabled labelName="Certification" id="ItemCertification" handleChange={this.handleChange} />
                     </div>
                     : null
                    }
                    <div className="flex-container-column input">
                      <DropDown id="countryOfOrigin" labelName="Country of Origin" errorMsg={errorMessages.countryOfOrigin ? '"countryOfOrigin" is required': ''} value={selectedItem.countryOfOrigin || ''} options={this.props.countryOfOrigins} placeHolderText="Select a Country of Origin" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <TextInput errorMsg={errorMessages.cost} value={selectedItem.cost ? selectedItem.cost.toString() : '0.00'} labelName="Vendor Cost" id="cost" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <TextInput errorMsg={errorMessages.deliveredCost} value={'deliveredCost' in selectedItem && selectedItem.deliveredCost !== null ? selectedItem.deliveredCost.toString() : '0.00'} labelName="Delivered Cost" id="deliveredCost" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <TextInput errorMsg={errorMessages.ti} value={selectedItem.ti.toString()} labelName="Item Ti" id="ti" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <TextInput errorMsg={errorMessages.hi} value={selectedItem.hi.toString()} labelName="Item Hi" id="hi" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <DropDown id="location" labelName="Location" errorMsg={errorMessages.location} value={selectedItem.location} options={this.props.locations} placeHolderText="Select a Location" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <DropDown id="cooler" labelName="Cooler" value={selectedItem.cooler || ''} options={this.state.coolers} placeHolderText="Select a Cooler" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <TextInput errorMsg={errorMessages.gtin} value={selectedItem.gtin ? selectedItem.gtin.toString() : ''} labelName="GTIN" id="gtin" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <TextInput errorMsg={errorMessages.upc} value={selectedItem.upc ? selectedItem.upc.toString() : ''} labelName="UPC" id="upc" handleChange={this.handleChange} />
                    </div>
                    <div className="flex-container-column input">
                      <TextInput errorMsg={errorMessages.plu} value={selectedItem.plu ? selectedItem.plu.toString() : ''} labelName="PLU" id="plu" handleChange={this.handleChange} />
                    </div>
                    { selectedItem.isBurdenFreightItem
                      ? <div className="flex-container-column input">
                          <DropDown id="unitType" labelName="Unit Type" value={selectedItem.unitType ? selectedItem.unitType : "Select a Unit"} options={unitTypeOptions} placeHolderText="Select a Unit" handleChange={this.handleChange} />
                        </div>
                      : null
                    }
                  </div>
                  : null
                  }

                  { selectedItem?.isBurdenItem
                    ? <div className="flex-container-row input">
                        <div className="flex-container-column input">
                          <TextInput value={selectedItem.itemId} isDisabled labelName="Item Number" id="VendorItemNumber" handleChange={this.handleChange} />
                        </div>
                        <div className="flex-container-column input description">
                          <TextInput errorMsg={errorMessages.description} isDisabled value={selectedItem.description} labelName="Description" id="description" handleChange={this.handleChange} />
                        </div>
                        <div className="flex-container-column input">
                          <TextInput errorMsg={errorMessages.cost} value={selectedItem.cost ? selectedItem.cost.toString() : '0.00'} labelName="Vendor Cost" id="cost" handleChange={this.handleChange} />
                        </div>
                        <div className="flex-container-column input">
                          <DropDown errorMsg={errorMessages.unitType} id="unitType" labelName="Unit Type" value={selectedItem.unitType ? selectedItem.unitType : "Select a Unit"} options={unitTypeOptions} placeHolderText="Select a Unit" handleChange={this.handleChange} />
                        </div>
                     </div>
                    : null
                  }

                  {
                   ((appConfig.PREMIUM_FEATURE_ACTIVE === "true") && ('certification' in selectedItem && selectedItem.certification !== null))
                   ? <div className="flex-container-row edit-premiums">
                     <Premiums premiumErrorMessages={this.state.premiumErrorMessages} selectedItem={selectedItem} currentVendorCategory={currentVendorCategory} handlePremiumChange={this.handlePremiumChange} />
                   </div>
                   : null
                  }

                <div className="flex-container-row item-count">
                  <div className="item-count-container">{`Editing Item ${this.state.currentItemLocation + 1} of ${selectedItems ? selectedItems.length : 0}`}</div>
                </div>

                { isSaving
                  ? <div className="flex-container-row edit-action-buttons">
                    <Pulse text='Saving.....' />
                  </div>
                  : <div className="flex-container-row edit-action-buttons">
                    <PrimaryButton onClick={() => this.handleSaveAndNextClose(-1)} name="Save and Previous" />
                    <PrimaryButton onClick={() => this.handleSaveAndNextClose(0)} name="Save and Next" />
                    <PrimaryButton onClick={() => this.handleSaveAndNextClose(1)} name="Save and Close" />
                    <SecondaryButton onClick={this.closeModal} name="Return to Dashboard" />
                  </div>
                }

              </div>
              )}
        </div>
        );
    }
}

export default EditItemModal;
